import i18n from 'services/base/i18n';

export default {
  // Page title of the registration page
  register: () => i18n.pgettext('Pages|Registration', 'Register'),

  // Label for the email address input
  email: () => i18n.pgettext('Pages|Registration', 'EMAIL ADDRESS'),

  // Label for the country input
  country: () => i18n.pgettext('Pages|Registration', 'COUNTRY'),

  // Label for the mobile number input
  mobileNumber: () => i18n.pgettext('Pages|Registration', 'MOBILE NUMBER'),

  // Label for the password input
  password: () => i18n.pgettext('Pages|Registration', 'PASSWORD'),

  // Text for the button that submits the registration form
  next: () => i18n.pgettext('Pages|Registration', 'NEXT'),
};
